import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import Grounds from '@ifeng-fe/three_terminal/es/base/grounds';

class Banner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    IS_IN_APP = typeof grounds !== 'undefined';

    goBack = () => {
        Grounds.close();
    };

    sharePage = () => {
        const {
            content: { shareTitle, shareBref, shareImage },
        } = this.props;

        Grounds.openShare(
            'https://finance.ifeng.com/studio?webkit=1',
            shareTitle || '凤凰全球快报',
            shareBref || '24小时全球财经速递',
            shareImage || 'https://p0.ifengimg.com/2019_19/7812F0690848DF15F2FA0248CE701CA0A823E558_w300_h300.png',
            0,
        );

        // window.grounds.newShare(
        //     JSON.stringify({
        //         shareurl: 'https://finance.ifeng.com/studio',
        //         title: '凤凰网财经直播室',
        //         desc: '24小时全球财经速递',
        //         thumbnail: '',
        //         cardType: 'finance',
        //         timestamp: String(new Date().getTime()),
        //         documentId: '',
        //     }),
        // );
    };

    render() {
        const {
            content: { image },
        } = this.props;

        return (
            <div className={styles.banner} style={{ backgroundImage: `url(${image})` }}>
                <div className={styles.actionLine}>
                    {this.IS_IN_APP ? <div className={styles.returnBackBtn} onClick={this.goBack} /> : null}
                    {this.IS_IN_APP ? <div className={styles.shareBtn} onClick={this.sharePage} /> : null}
                </div>
            </div>
        );
    }
}

export default Banner;
